import Navigation from "./modules/Navigation";
import OduWithdrawal from "./modules/OduWithdrawal";
import {edroneNewsletter} from "./modules/Newsletter";
import {YouTubeEmbed} from "./modules/YoutubeVideo";
import wbsExcerpts from "./modules/Excerpts";
import WEBsellentModal from "./modules/WEBsellentModal";
import Search from "./modules/Search";
import Quantity from "./modules/Quantity";
import {wbsCarousels} from "./modules/wbsCarousels";
import {InstagramFix} from "./modules/InstagramFix";
import {DetailsToggle} from "./modules/DetailsToggle";
import {WEBsellentAccordion} from "./modules/WEBsellentAccordion";
import {miniCartUpsellQuantity, toggleMiniCart, WbsMiniCart} from "./modules/wbsMiniCart";
import {CartPage, rememberCategory} from "./modules/checkout-flow/CartPage";
import {CheckoutFlow} from "./modules/checkout-flow/CheckoutFlow";
import {ThankYou} from "./modules/checkout-flow/ThankYou";
import Toasts from "./modules/Toasts";


new Navigation();
OduWithdrawal();
new WEBsellentModal('.openModal', '.posts-search');
Search();
Quantity();
wbsCarousels();
toggleMiniCart();
WbsMiniCart();
miniCartUpsellQuantity();

edroneNewsletter('#newsletterForm');

YouTubeEmbed();

wbsExcerpts({
    sections: '.testimonials__content',
    excerpt: '.testimonials__excerpt',
    expandButton: '.testimonials_expand',
    full: '.testimonials-content__full'
});

wbsExcerpts({
    sections: '.featured-reviews__item',
    excerpt: '.featured-reviews__excerpt',
    expandButton: '.featured-reviews__expand',
    full: '.featured-reviews__full'
})


DetailsToggle();

InstagramFix();

WEBsellentAccordion();

Toasts();

// Cart and three-step checkout (woocommerce/cart, woocommerce/checkout).
CartPage();
CheckoutFlow();
ThankYou();
rememberCategory();


function ekomiReviewsText() {
    const widget = document.querySelector('.product-content__title .ekomi-widget-container');

    if (widget === null) {

        return;
    }

    const reviewsTextWrapper = widget.querySelector('.total_reviews');

    if (reviewsTextWrapper) {


        const observer = new MutationObserver((mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList' || mutation.type === 'characterData') {


                    updateReviewsText(reviewsTextWrapper);
                    observer.disconnect(); // Stop observing once the text is set
                }
            }
        });


        observer.observe(reviewsTextWrapper, {childList: true, subtree: true, characterData: true});
    } else {


        const observer = new MutationObserver((mutationsList, observer) => {
            const newReviewsTextWrapper = widget.querySelector('.total_reviews');
            if (newReviewsTextWrapper) {

                updateReviewsText(newReviewsTextWrapper);
                observer.disconnect();
                ekomiReviewsText();
            }
        });

        observer.observe(widget, {childList: true, subtree: true});
    }


    function updateReviewsText(element) {
        if (!element || !element.textContent) return;

        let text = element.textContent;

        // Extract the number from the text
        let match = text.match(/(\d+)/);
        if (match) {
            let number = parseInt(match[0], 10);
            let correctWord = getCorrectPolishForm(number);
            element.textContent = `(${number} ${correctWord})`;
        }
    }

// Function to determine correct form of "opinie"
    function getCorrectPolishForm(number) {
        if (number === 1) {
            return "opinia";
        } else if (number % 10 >= 2 && number % 10 <= 4 && (number < 12 || number > 14)) {
            return "opinie";
        } else {
            return "opinii";
        }
    }

}

document.addEventListener('DOMContentLoaded', function () {
    ekomiReviewsText();
})

function sendUpdateCartEventForKlar() {
    jQuery.ajax({
        url: woocommerce_params.ajax_url,
        data: {
            action: 'wbs_get_cart_data'
        },
        type: 'GET',
        success: function (response) {
            if (response.success && response.data.cartId) {
                window._k_q = window._k_q || [];
                window._k_q.push(["Klar:sendUpdateCartEvent", {
                    cartId: response.data.cartId
                }]);
            } else {
                console.warn("No cart data found.");
            }
        },
        error: function (error) {
            console.error("Error fetching cart data:", error);
        }
    });
}

jQuery(document.body).on('wc_fragments_refreshed wc_fragment_refresh added_to_cart removed_from_cart updated_cart_totals', function () {
    sendUpdateCartEventForKlar();
});
